import { entityLabel } from '../../../../shared/utils/entitySelection';
import { useState } from 'react';
import { createMandateDocument } from '@/modules/documents/services';
import { getInitialMandateForm } from '@/modules/documents/utils';
import { toast } from '../../../../shared/hooks/use-toast';

export function useMandateForm({ clients, onCreate }) {
  const [form, setForm] = useState(getInitialMandateForm());
  const [isSubmitting, setIsSubmitting] = useState(false);

  function updateField(field, value) {
    setForm((prev) => {
      if (field === 'clientIds') {
        const selected = value.map((id) => clients.find((client) => String(client.id) === String(id))).filter(Boolean);
        return { ...prev, clientIds: value, clientId: value[0] || '', client: selected.map(entityLabel).join('; '), firmatario: selected.map((client) => client.name || entityLabel(client)).join('; ') };
      }
      if (field === 'clientId') {
        const selectedClient = clients.find((client) => String(client.id) === String(value));
        return {
          ...prev,
          clientId: value,
          client: selectedClient?.name || '',
          firmatario: selectedClient?.name || '',
        };
      }

      return {
        ...prev,
        [field]: value,
      };
    });
  }

  function reset() {
    setForm(getInitialMandateForm());
  }

  async function submit() {
    setIsSubmitting(true);
    const result = await createMandateDocument(form);
    setIsSubmitting(false);

    if (!result.ok) {
      toast({ title: 'Mandato non creato', description: result.message, variant: 'destructive' });
      return false;
    }

    await onCreate(result.data.document);
    reset();
    toast({ title: 'Mandato creato', description: result.message });
    return true;
  }

  return {
    form,
    isSubmitting,
    updateField,
    reset,
    submit,
  };
}
